import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, LicitacaoOrgaoAudesp } from 'eddydata-lib';

@Injectable({
    providedIn: 'root'
})
export class LicitacaoOrgaoAudespService extends BaseResourceService<LicitacaoOrgaoAudesp> {

    constructor(
        protected injector: Injector
    ) {
        super(`licitacao-orgao-audesps`, injector);
    }
}
